module.exports = __webpack_public_path__ + "img/vertical_5_1_6005.70fd6a68.png";